import React, { Component } from 'react'; //different
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
// import './style.css';
import Main from './main';
import Logout from './logout';
import Systems from "./SystemFunction";
import io from "socket.io-client";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
    
    }
  }
 async componentDidMount() {
   // await this.callgetthemesv(Systems);
    const endpoint = "https://apisock.newworld.center";
    const socket = io.connect(endpoint);
    var roomid = Systems;
    var obj = { roomid }
    var json = JSON.stringify(obj);
    socket.on('connect', function (data) {
      var obj = { roomid }
      var json = JSON.stringify(obj);
      socket.emit('new', json);
    });

  }


  render() {

    return (
      < >
          <BrowserRouter >
            <Routes>
              <Route path="/*" element={<Main />} />
              <Route path="/logout" element={<Logout />} /> 
            </Routes>
          </BrowserRouter>      

        <ToastContainer />
      </>
    );
  }
}

export default App;
